import { TrendItemsApi } from 'api/TrendItemsApi';
import { backendApiClient } from 'container/backendApiClient';

export const trendItemsApi = new TrendItemsApi(backendApiClient);
